import axios from './config/config-viva';

const defaultRoute = 'agendamentos/';

export default {
  list: (
    conveniado = null,
    local = null,
    data = null,
    page = null,
    status = null
  ) =>
    axios.get(
      `${defaultRoute}?${conveniado ? 'conveniado=' + conveniado._id : ''}${
        data ? '&data=' + data : ''
      }${page ? '&page=' + page : ''}${status ? '&status=' + status : ''}`
    ),
  findConsumo: async (clienteId, contractedId) => {
    const response = await axios.get(
      `${defaultRoute}consumo/${clienteId}`,
      {
        params: {
          contractedId,
        },
      }
    )

    return response.data
  },
  findDaysWitScheduling: (conveniadoId, status = null) =>
    axios.get(
      `${defaultRoute}conveniado/scheduling-days/${conveniadoId}${
        status ? '?status=' + status : ''
      }`
    ),
  findLimitPerDay: (limit) =>
    axios.patch(`${defaultRoute}conveniado/limit-per-days`, limit),
  changeByDate: (changeOptions) =>
    axios.patch(`${defaultRoute}conveniado/change-by-date`, changeOptions),
  findById: (id, hideConveniado) =>
    axios.get(
      `${defaultRoute + id}${
        hideConveniado ? '?hideConveniado=' + hideConveniado : ''
      }`
    ),
  create: (agendamento) => axios.post(defaultRoute, agendamento),
  createMany: (agendamentos) => axios.post(defaultRoute + 'many', agendamentos),
  confirmar: (agendamento) =>
    axios.post(`${defaultRoute}confirmar`, agendamento),
  update: (id, agendamento) => axios.put(defaultRoute + id, agendamento),
  remove: (id) => axios.delete(defaultRoute + id),
  updateStatusService: (id, status_atendimento) => axios.put(`${defaultRoute}update-status-service/${id}`, {status_atendimento: status_atendimento}),
}